@let user = userData(); @if (!user) {
<div class="bg-white px-4 rounded-xl shadow-sm">
  <nz-spin nzSimple></nz-spin>
</div>
} @else {
<!-- Each tab body is wrapped in <ng-template nz-tab> so its child component
       (and that component's data fetch) is only instantiated when the tab is
       first opened, instead of all tabs loading on drawer open. -->
<nz-tabset [(nzSelectedIndex)]="selectedTab">
  <nz-tab nzTitle="{{ 'users.information' | translate }}">
    <ng-template nz-tab>
      <beautyapp-user-overview-panel
        [user]="user"
        (edit)="addOrEdit($event)"
        (verify)="userVerify($event)"
        (refresh)="getEmployee(user.id)"
        (openGiftPackages)="showGiftPackages()"
      ></beautyapp-user-overview-panel>
    </ng-template>
  </nz-tab>
  <nz-tab nzTitle="{{ 'users.historyVisits' | translate }}">
    <ng-template nz-tab>
      <beautyapp-user-booking-history [userId]="user.id" />
    </ng-template>
  </nz-tab>
  <nz-tab nzTitle="{{ 'users.transactions' | translate }}">
    <ng-template nz-tab>
      <beautyapp-user-transactions
        [userId]="user.id"
      ></beautyapp-user-transactions>
    </ng-template>
  </nz-tab>
  <nz-tab nzTitle="{{ 'statistic.consignation.title' | translate }}">
    <ng-template nz-tab>
      <beautyapp-user-consignations
        [userId]="user.id"
      ></beautyapp-user-consignations>
    </ng-template>
  </nz-tab>
  <nz-tab nzTitle="{{ 'servicePackages.title' | translate }}">
    <ng-template nz-tab>
      <beautyapp-user-packages [userId]="user.id"></beautyapp-user-packages>
    </ng-template>
  </nz-tab>
  @if (ehrActive()) {
  <nz-tab nzTitle="{{ 'EHR' | translate }}">
    <ng-template nz-tab>
      <beautyapp-user-ehr [userId]="user.id" />
    </ng-template>
  </nz-tab>
  }
  <nz-tab nzTitle="Customer 360">
    <ng-template nz-tab>
      <beautyapp-customer-360-content [userId]="user.id" />
    </ng-template>
  </nz-tab>
  <nz-tab nzTitle="კომუნიკაცია">
    <ng-template nz-tab>
      <beautyapp-customer-360-communications [userId]="user.id" />
    </ng-template>
  </nz-tab>
  <nz-tab nzTitle="{{ 'users.consentsHistory' | translate }}">
    <ng-template nz-tab>
      <beautyapp-user-consent-history [userId]="user.id" />
    </ng-template>
  </nz-tab>
</nz-tabset>
}
